import Vue from 'vue'
import Vuex from 'vuex'
import LanguageModule from './modules/language';
import MediaModule from './modules/media';
import TextAssetModule from './modules/textassets';
import AssetModule from './modules/assets';
import DrawerModule from './modules/drawer';
import SettingsDrawerModule from './modules/settings';
import ErrorModule from './modules/error';
import JourneyModule from './modules/journey';
import AssessmentModule from './modules/assessment';
import PersonModule from './modules/person';
import AuthModule from './modules/auth';
import SpeedTest from './modules/speedtest';
import Videos from './modules/videos';
import Persistor from './storePersist'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    globalLoading : false,
  },
  mutations: {
    setGlobalLoading(state,loading){
      state.globalLoading=loading;
    }
  },
  actions: {
    startLoading({commit}){
      commit('setGlobalLoading',true);
    },
    stopLoading({commit}){
      commit('setGlobalLoading',false);
    }
  },
  modules: {
    media: MediaModule,
    textassets: TextAssetModule,
    assets: AssetModule,
    drawer: DrawerModule,
    settings: SettingsDrawerModule,
    error: ErrorModule,
    journey: JourneyModule,
    language: LanguageModule,
    auth: AuthModule,
    assessment: AssessmentModule,
    person: PersonModule,
    speedtest: SpeedTest,
    videos: Videos,
  },
  plugins: [
   Persistor
  ]
})
